
import React from 'react';
import { useNavigate } from "react-router-dom";
import { EventBasicInfo } from "./EventBasicInfo";
import { Event } from "@/types/event";
import { EventDetailsAccordion } from "./accordion/EventDetailsAccordion";

interface GuestEventViewProps {
  event: Event;
  rsvpStatus?: 'invited' | 'accepted' | 'declined' | 'maybe';
  onRemoveGuest?: (userId: string) => void;
}

export const GuestEventView = ({ 
  event, 
  rsvpStatus, 
  onRemoveGuest 
}: GuestEventViewProps) => {
  const navigate = useNavigate();
  const isGuestRsvpComplete = rsvpStatus === 'accepted' || rsvpStatus === 'declined' || rsvpStatus === 'maybe';
  
  const handleRsvp = () => {
    navigate(`/events/${event.event_id}/rsvp`);
  };
  
  // Check if event has recommendations
  const hasRecommendations = (event.event_date_recommendations && event.event_date_recommendations.length > 0) || 
                            (event.event_venue_recommendations && event.event_venue_recommendations.length > 0);
  
  // Attendees already have the correct format from our useEventFetch hook
  const attendees = event.attendees || [];
  
  return (
    <div className="space-y-6 pb-6">
      <EventBasicInfo
        name={event.name}
        description={event.description || ""}
        eventDate={event.event_date}
        imageUrl={event.image_url}
        eventImages={event.additional_images}
        status={event.status}
        locationType={event.location_type}
        flexibleLocationDescription={event.flexible_location_description || ""}
        preferredDates={event.preferred_dates}
        preferredVenues={event.preferred_venues}
        preferredTimeOfDay={event.preferred_time_of_day}
        selectedVenue={event.selectedVenue}
        selectedDate={event.selectedDate}
        host={event.host ? {
          full_name: event.host.full_name,
          avatar_url: event.host.avatar_url
        } : undefined}
        isHost={false}
        eventId={event.event_id}
        event_deadline={event.event_deadline}
        rsvpStatus={rsvpStatus}
        guestRsvpComplete={isGuestRsvpComplete}
        hasRecommendations={hasRecommendations}
        onRsvp={handleRsvp}
        attendees={attendees}
        event={event}
      />
      
      <div className="px-4">
        <EventDetailsAccordion 
          event={event}
          isHost={false}
          rsvpStatus={rsvpStatus}
          onRemoveGuest={undefined}
        />
      </div>
    </div>
  );
};
